// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"120":"ddf5b40e","268":"eb395145","302":"3be281d3","344":"3e012343","551":"ca5e1ea2","564":"87b9b2e8","950":"f1b9d16e"}[chunkId] + ".chunk.js";
};